export default "__VITE_ASSET__Bczcs5IM__"